import Splide from '@splidejs/splide';

const gk_displayBlock = {
  load() {
    const blocks = document.querySelectorAll('.DisplayBlock');
    blocks.forEach((block) => {
      if (block.dataset.gkInit) return;
      block.dataset.gkInit = '1';

      if (block.dataset.mode === 'slider') {
        this.initSplide(block);
      } else if (block.dataset.mode === 'parallax') {
        this.initParallax(block);
      }
    });
  },

  /**
   * Mode parallaxe : toutes les cartes se collent au même top et se
   * recouvrent. Pour que le recouvrement soit parfait sans rien couper, on
   * aligne chaque carte sur la hauteur de la PLUS HAUTE (mesurée au naturel).
   */
  initParallax(block) {
    const stack = block.querySelector('.DisplayBlock-parallaxStack');
    if (!stack) return;

    const items = Array.from(stack.querySelectorAll('.-parallaxItem'));
    if (items.length < 2) return;

    const equalize = () => {
      // 1. reset → on retombe sur la hauteur naturelle (min-height CSS inclus)
      items.forEach((it) => { it.style.height = ''; });
      // 2. mesure de la plus haute
      let max = 0;
      items.forEach((it) => { max = Math.max(max, it.offsetHeight); });
      // 3. on aligne tout le monde dessus → recouvrement net, rien de coupé
      items.forEach((it) => { it.style.height = `${max}px`; });
    };

    equalize();

    // Les images modifient la hauteur une fois chargées → recalcul
    block.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', equalize, { once: true });
    });

    // Recalcul au redimensionnement (vh / padding / reflow du texte changent)
    let raf;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(equalize);
    });
  },

  initSplide(block) {
    const splideEl = block.querySelector('.DisplayBlock-splide');
    if (!splideEl) return;

    const slideCount = splideEl.querySelectorAll('.splide__slide').length;
    if (slideCount < 2) return;

    const speed               = parseInt(block.dataset.speed, 10) || 750;
    const autoplay            = block.dataset.autoplay === '1';
    const autoplaySpeed       = parseInt(block.dataset.autoplaySpeed, 10) || 5000;
    const rewind              = block.dataset.rewind === '1';
    const showArrows          = block.dataset.showArrows === '1';
    const arrowsPosition      = block.dataset.arrowsPosition || 'middle';
    const showDots            = block.dataset.showDots === '1';

    const perPageDesktopLarge = parseInt(block.dataset.perPageDesktopLarge, 10) || 4;
    const perPageDesktop      = parseInt(block.dataset.perPageDesktop, 10) || 3;
    const perPageTabletLarge  = parseInt(block.dataset.perPageTabletLarge, 10) || 3;
    const perPageTablet       = parseInt(block.dataset.perPageTablet, 10) || 2;
    const perPageMobileLarge  = parseInt(block.dataset.perPageMobileLarge, 10) || 2;
    const perPageMobile       = parseInt(block.dataset.perPageMobile, 10) || 1;

    const safeMax = (n) => Math.min(n, slideCount);

    const splide = new Splide(splideEl, {
      type:         rewind ? 'loop' : 'slide',
      start:        0,
      focus:        0,
      trimSpace:    true,
      perPage:      safeMax(perPageDesktopLarge),
      perMove:      1,
      speed,
      autoplay,
      interval:     autoplaySpeed,
      pauseOnHover: true,
      pauseOnFocus: true,
      arrows:       showArrows,
      pagination:   showDots,
      gap:          'var(--dp-gap, 16px)',
      padding:      { left: 0, right: 0 },
      easing:       'cubic-bezier(0.76, 0, 0.24, 1)',
      keyboard:     'global',
      breakpoints: {
        1199: { perPage: safeMax(perPageDesktop) },
        1023: { perPage: safeMax(perPageTabletLarge) },
         990: { perPage: safeMax(perPageTablet) },
         767: { perPage: safeMax(perPageMobileLarge) },
         399: { perPage: safeMax(perPageMobile) },
      },
    });

    splide.mount();
    splideEl._splide = splide;

    if (showArrows && arrowsPosition !== 'middle') {
      splideEl.classList.add(`-arrowsPos-${arrowsPosition}`);
    }
  },
};


const gk_displayBlock_containRadius = {
  init() {
    document.querySelectorAll('.DisplayBlock-image.-fit-contain img').forEach((img) => {
      if (img.complete && img.naturalWidth) {
        this.apply(img);
      } else {
        img.addEventListener('load', () => this.apply(img));
      }
    });
  },

  apply(img) {
    const container = img.closest('.DisplayBlock-image');
    if (!container) return;

    const block = img.closest('.DisplayBlock');
    if (!block) return;

    const radius = getComputedStyle(block).getPropertyValue('--dp-image-radius').trim();
    if (!radius || radius === '0' || radius === '0px') return;

    const cW = container.offsetWidth;
    const cH = container.offsetHeight;
    const nW = img.naturalWidth;
    const nH = img.naturalHeight;
    if (!nW || !nH || !cW || !cH) return;

    const scale     = Math.min(cW / nW, cH / nH);
    const rW        = nW * scale;
    const rH        = nH * scale;
    const insetTop  = (cH - rH) / 2;
    const insetLeft = (cW - rW) / 2;

    img.style.clipPath = `inset(${insetTop}px ${insetLeft}px round ${radius})`;
  },
};

document.addEventListener('DOMContentLoaded', () => gk_displayBlock_containRadius.init());

export default gk_displayBlock;
